// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCfVK6_Vem-n9fkaA7ThnRj32Sz2LI1Z0g",
    authDomain: "ema-jhon-simple-d0454.firebaseapp.com",
    projectId: "ema-jhon-simple-d0454",
    storageBucket: "ema-jhon-simple-d0454.appspot.com",
    messagingSenderId: "712898593009",
    appId: "1:712898593009:web:632ccee738c4db586e6950"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;